import aboutHero from "../assets/about-hero.png";
import aboutCtaGlobe from "../assets/about-cta-globe.png";
import aboutVisionBg from "../assets/about-vision-bg.png";
import about01 from "../assets/about01.png";
import about02 from "../assets/about02.png";
import about03 from "../assets/about03.png";
import about04 from "../assets/about04.png";
import sundeus05 from "../assets/sundeus05.jpg";
import sundeus06 from "../assets/sundeus06.jpg";
import avatarOne from "../assets/avatarOne.png";
import avatarThree from "../assets/avatarThree.png";
import teamPawan from "../assets/team-pawan.png";

export const aboutHeroContent = {
  title: "Building the Future with",
  titleHighlight: "AI, Technology & Digital Consulting",
  description:
    "Sundeus Technology is a team of technologists and innovators dedicated to helping businesses grow through smart digital solutions. Operating across the UK, US, and India, we combine expertise in cloud, AI, and enterprise technology to deliver impactful, scalable results.",
  image: aboutHero,
  imageAlt: "Sundeus team collaborating",
};

export const aboutHeroFeatures = [
  {
    title: "AI First Approach",
    subtitle: "Innovation at the core",
  },
  {
    title: "Expert Team",
    subtitle: "Passionate problem solvers",
  },
  {
    title: "Impact Driven",
    subtitle: "Real Business Results",
  },
];

export const aboutHeroStats = [
  { value: "50+", label: "Projects Delivered" },
  { value: "10+", label: "Industries Served", multiline: true },
  { value: "96%", label: "Client Satisfaction" },
  { value: "10+", label: "AI & Data Projects" },
];

export const whoWeAreContent = {
  label: "WHO WE ARE",
  title: "We Build. We Solve. We Grow Together.",
  subtitle:
    "We are a full-service digital solutions company delivering innovative web, mobile, cloud, and marketing services that drive real business results. Our mission is simple—empower businesses with technology that creates impact.",
  values: [
    {
      title: "Customer centric",
      description:
        "Putting Customer outcomes at the center of every decisiong we do.",
    },
    {
      title: "Ownership",
      description: "Taking responsiblity and delivering on commitments",
    },
    {
      title: "Excellence",
      description: "Striving for quality in every solution and interaction",
    },
    {
      title: "Growth mindset",
      description: "Learning ,adapting and continously improving",
    },
  ],
};

export const visionContent = {
  label: "OUR VISION",
  title: "To Be a Global Digital Transformation Partner",
  subtitle:
    "We envision a world where technology empowers every business to innovate, grow, and create a lasting impact.",
  background: aboutVisionBg,
  checklist: [
    "Empower businesses with smart solutions",
    "Drive innovation with emerging technologies",
    "Build long-term relationships based on trust",
  ],
};

export type TimelineEntry = {
  year: string;
  title: string;
  description: string;
  image: string;
  imageAlt: string;
  imageOnLeft: boolean;
};

export const journeyTimeline: TimelineEntry[] = [
  {
    year: "2019",
    title: "The Foundation",
    description:
      "Sundeus Technology was founded as a product engineering company with a strong focus on designing and developing innovative software solutions. By combining deep engineering expertise with a customer-centric approach, S Technology sought to address the growing need for efficient and scalable contract lifecycle management across industries.",
    image: about01,
    imageAlt: "Sundeus foundation",
    imageOnLeft: true,
  },
  {
    year: "2022",
    title: "Expanding Into Consulting",
    description:
      "S Consulting was established with a mission to bridge the gap between advanced technology and real-world business challenges. By combining deep technical expertise with strategic consulting, we began helping organizations accelerate digital transformation and unlock new growth opportunities",
    image: about02,
    imageAlt: "Consulting expansion",
    imageOnLeft: false,
  },
  {
    year: "2023",
    title: "Global Growth & Innovation",
    description:
      "We successfully delivered multiple enterprise-grade projects across the US, UK, and India. This milestone year also marked the launch of our AI Innovation Center, dedicated to exploring emerging technologies, developing intelligent solutions, and driving business innovation through artificial intelligence.",
    image: about03,
    imageAlt: "Global growth",
    imageOnLeft: true,
  },
  {
    year: "2024",
    title: "Entering the AI Era",
    description:
      "To strengthen our commitment to AI-led transformation, we launched Sundeus.ai, a dedicated initiative focused on building next-generation AI products and solutions. During the same year, we expanded our global presence by officially registering operations in both the United Kingdom and India, creating a stronger foundation for international growth.",
    image: about04,
    imageAlt: "AI era launch",
    imageOnLeft: false,
  },
  {
    year: "2025",
    title: "Scaling the Future",
    description:
      "Today, we are focused on building next-generation digital platforms, AI-powered applications, and intelligent automation solutions for businesses worldwide. As we continue expanding into new geographies and industry verticals, our goal remains the same: helping organizations innovate faster, operate smarter, and create sustainable long-term value through technology.",
    image: sundeus05,
    imageAlt: "Scaling the future",
    imageOnLeft: true,
  },
  {
    year: "2026",
    title: "Scaling New Horizons",
    description:
      "Launched next-generation AI and SaaS platforms, including Insurance Quote to Buy AI Solutions, Sundeus Portal and Settlr, while accelerating global growth through innovation, partnerships, and startup ecosystem initiatives.",
    image: sundeus06,
    imageAlt: "Scaling new horizons",
    imageOnLeft: false,
  },
];

export type TeamMember = {
  name: string;
  role: string;
  photo: string;
  bio: string;
};

export const teamMembers: TeamMember[] = [
  {
    name: "DHEERAJ GUPTA",
    role: "CEO",
    photo: avatarOne,
    bio: "25+ years of IT industry experience in strategic enterprise architecture consulting & organization wide transformation programs. Worked across companies like Hexaware Zensar, IBM.",
  },
  {
    name: "PAWAN YADAV",
    role: "CONSULTING PARTNER",
    photo: teamPawan,
    bio: "25+ years of Global IT Delivery experience in Logistics, Supply Chain, Manufacturing and Financial Services Sector. Global exposure working at client site – USA 6+yrs and UK. Worked for clients such as Bank of America, Visa, Citi, Amex etc.",
  },
  {
    name: "JNANENDRA SARKAR",
    role: "CTO",
    photo: avatarThree,
    bio: "22+ years of experience in product development and digital transformation, specializing in AI/ML and Generative AI. He has worked at NielsenIQ LTIMindtree, TCS and Vodafone, and he holds US patents in artificial intelligence.",
  },
];

export const aboutCtaContent = {
  title: "Let's Build the Future Together",
  subtitle:
    "Whether you're a startup looking to launch your MVP or an enterprise undergoing digital transformation.",
  image: aboutCtaGlobe,
  imageAlt: "Global digital transformation illustration",
};
